import customEvent from './customEvent'
import dataLayer from './dataLayer'
import history from './history'
import logger from './logger'
import root from './root'
import tracker from './tracker'
import version from './version'
import { LOADED } from './eventTypes'

// Init customEvent polyfill for old ie browsers.
customEvent()

// Define lib
const lib = {
  version,
  connected: root.connected || false,
  enabled: root.enabled || false,
  loggable: root.loggable || false,
  logger,
  get: dataLayer.get,
  set: dataLayer.set,
  getHistory: history.get,
  trigger: tracker.trigger,
  triggerType: tracker.triggerType
}

// Map lib to root object
Object.assign(root, lib)

// Tell the world that we have loaded
window.dispatchEvent(new CustomEvent(LOADED))

// Display version in console
setTimeout(() => { logger.info('Tracker', `v${version} loaded`) })

// export default lib
export default lib
